define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var SettingsModel = /** @class */ (function () {
        function SettingsModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable();
            this.Key = ko.observable();
            this.Description = ko.observable();
            this.Value = ko.observable();
            this.InputType = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, SettingsModel.Mapping, self);
            }
        }
        SettingsModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new SettingsModel(options.data);
            }
        };
        return SettingsModel;
    }());
    return SettingsModel;
});
//# sourceMappingURL=SettingsModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/SettingsModel.js
// module id = 182
// module chunks = 2